/**
 * Ce que le fil rend du design system, hors du crochet testé (Unistyles ne se charge pas sous Jest, le test du fil
 * remplace ce module) :
 *  - par-dessus la salle (`TutorLiveLayer.sheet`) : le recadrage d'une image déposée ou collée
 *    (`TutorImageCropStep`, au web), et l'aperçu d'une photo prise avec le champion (`TutorMediaPreviewModal`,
 *    « Créer une activité »). Une seule à la fois, comme l'ancien live ;
 *  - dans le champ (`composer.editor`) : la puce de génération dépliée sur place (`<TutorSessionSettingSheet
 *    inline>`). Le formulaire de génération en modale n'existe plus dans la salle.
 */
import React, { useMemo } from "react"

import { TutorImageCropStep } from "../../../../../../design-system/templates/TutorImageCropStep"
import { TutorMediaPreviewModal } from "../../../../../../design-system/templates/TutorMediaPreviewModal"
import { TutorSessionSettingSheet } from "../../../../../../design-system/templates/TutorSessionSettingSheet"
import { type TutorLiveFeedGeneration } from "./useTutorLiveFeedGeneration"

export function useTutorLiveFeedSheet(args: {
    generation: TutorLiveFeedGeneration
    preview: { uri: string; onClose: () => void; onCreateActivity: () => void } | null
}): { sheet: React.ReactNode; editor: React.ReactNode } {
    const { generation, preview } = args
    const { crop, settingEditor } = generation
    const editor = useMemo(
        () => (settingEditor != null ? <TutorSessionSettingSheet {...settingEditor} /> : undefined),
        [settingEditor]
    )
    const sheet = useMemo(() => {
        if (preview != null) {
            return (
                <TutorMediaPreviewModal
                    visible
                    onClose={preview.onClose}
                    media={{ kind: /\.pdf($|\?)/i.test(preview.uri) ? "document" : "image", uri: preview.uri }}
                    onCreateActivity={preview.onCreateActivity}
                />
            )
        }
        if (crop != null) return <TutorImageCropStep {...crop} />
        return undefined
    }, [preview, crop])
    return { sheet, editor }
}
